import styled, { css } from 'styled-components'

export const CheckboxContainer = styled.label`
    display: flex;
    align-items: center;
    user-select: none;
    margin-bottom: 16px;
    ${({ noMargin }) => (
        noMargin &&
        css`
            margin: 0;
        `
    )}
    ${({ disabled }) => (
        disabled &&
        css`
            pointer-events: none;
            cursor: not-allowed;
        `
    )}
    ${({ flexEnd }) => (
        flexEnd &&
        css`
           justify-content: flex-end;
        `
    )}
`

export const StyledIcon = styled.svg`
    fill: none;
    stroke: ${({ theme }) => theme.grassyGreen};
    stroke-width: 2px;
`

export const StyledLabel = styled.div`
    margin-left: 5px;
`

export const StyledHiddenCheckbox = styled.input.attrs({ type: 'checkbox', hidden: true })``

export const StyledCheckbox = styled.div`
    width: 24px;
    height: 24px;
    background-color: ${({ theme }) => theme.whiteTwo};
    border: ${({ theme }) => `1px solid ${theme.veryLightPink}`};
    border-radius: 2px;
    transition: all 0.15s;
    margin-right: 10px;

    ${({ active }) =>
        active &&
        css`
            border: ${({ theme }) => `1px solid ${theme.grassyGreen}`};
            `
    };

    ${StyledIcon} {
        visibility: ${({ active }) => (active ? 'visible' : 'hidden')};
    }
`